import { useSelector } from "react-redux";

export default function useGetUpdatedTourneyTabsList() {
  let data = useSelector((state) => state?.lobby?.tourneyLobbyTabs);
  let tabs = Array.isArray(data) ? [...data] : [];
  return tabs
    .sort((a, b) => a?.tabSequenceA23 - b?.tabSequenceA23)
    .filter((item) => item.platform?.includes(import.meta.env.VITE_APP_NAME == 'A23' ? 'A23Poker' : 'Adda52'));
}
